import type { GetItem } from "@mnk/shared/models/item";
import ArticleIcon from "@mui/icons-material/Article";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FolderIcon from "@mui/icons-material/Folder";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ChangeNameModal } from "./ChangeNameModal";
import { DeleteFolderModal } from "./DeleteFolderModal";
import { DeleteProjectModal } from "./DeleteProjectModal";
import { NoItems } from "./NoItems";
interface Props {
  items: GetItem[];
  setIsNewFolderModalOpen: (isOpen: boolean) => void;
  setIsNewProjectModalOpen: (isOpen: boolean) => void;
  mutateItems: () => Promise<void>;
}

export const ItemListView = ({ items, setIsNewFolderModalOpen, setIsNewProjectModalOpen, mutateItems }: Props) => {
  const [selectedItem, setSelectedItem] = useState<GetItem | null>(null);
  const [isChangeNameModalOpen, setIsChangeNameModalOpen] = useState(false);
  const [isDeleteProjectModalOpen, setIsDeleteProjectModalOpen] = useState(false);
  const [isDeleteFolderModalOpen, setIsDeleteFolderModalOpen] = useState(false);

  if (items.length === 0) {
    return (
      <NoItems setIsNewFolderModalOpen={setIsNewFolderModalOpen} setIsNewProjectModalOpen={setIsNewProjectModalOpen} />
    );
  }

  return (
    <div className="gap-4 bg-white rounded-lg p-4">
      {items.map((item) => (
        <div key={item.id} className="border-b border-gray-200 p-4 flex justify-between items-center">
          {item.itemType === "folder" ? (
            <Link to={`/folders/${item.id}`} className="text-md flex items-center gap-2 flex-1">
              <FolderIcon className="w-3 h-3" />
              {item.name}
            </Link>
          ) : (
            <Link to={`/projects/${item.id}`} className="text-md flex items-center gap-2 flex-1">
              <ArticleIcon className="w-3 h-3" />
              {item.name}
            </Link>
          )}
          <div className="flex gap-4">
            <button
              type="button"
              onClick={() => {
                setSelectedItem(item);
                setIsChangeNameModalOpen(true);
              }}
              className="text-gray-500 hover:text-gray-700 items-center gap-1 flex cursor-pointer"
            >
              <EditIcon className="w-2 h-2" />
              名称変更
            </button>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-700 items-center gap-1 flex cursor-pointer"
              onClick={() => {
                setSelectedItem(item);
                if (item.itemType === "project") {
                  setIsDeleteProjectModalOpen(true);
                } else {
                  setIsDeleteFolderModalOpen(true);
                }
              }}
            >
              <DeleteIcon className="w-2 h-2" />
              削除
            </button>
          </div>
        </div>
      ))}
      {selectedItem && (
        <ChangeNameModal
          isOpen={isChangeNameModalOpen}
          onClose={() => {
            setIsChangeNameModalOpen(false);
            setSelectedItem(null);
          }}
          item={selectedItem}
          mutateItems={mutateItems}
        />
      )}
      {isDeleteProjectModalOpen && selectedItem && (
        <DeleteProjectModal
          onClose={() => setIsDeleteProjectModalOpen(false)}
          item={selectedItem}
          afterDeleteProject={mutateItems}
        />
      )}
      {isDeleteFolderModalOpen && selectedItem && (
        <DeleteFolderModal
          onClose={() => setIsDeleteFolderModalOpen(false)}
          item={selectedItem}
          afterDeleteFolder={mutateItems}
        />
      )}
    </div>
  );
};
